import { workApi } from "../Config/workConfig";

// Discussions live in the Work API; this client sends the Accounts token there.
export const DiscussionsApi = {
  me: () => workApi.get("discussions/me"),
  list: (params) => workApi.get("discussions", { params }),
  unreadCount: () => workApi.get("discussions/unread-count"),
  counts: () => workApi.get("discussions/counts"),
  editPost: (id, body) => workApi.patch(`discussions/${id}/post`, body),
  editResponse: (id, responseId, description) => workApi.patch(`discussions/${id}/responses/${responseId}`, { description }),
  edits: (id, responseId) => workApi.get(`discussions/${id}/edits`, { params: { responseId: responseId ?? undefined } }),
  people: (search) => workApi.get("discussions/people", { params: { search: search || undefined, limit: 20 } }),
  get: (id) => workApi.get(`discussions/${id}`),
  create: (body) => workApi.post("discussions", body),
  markRead: (id) => workApi.post(`discussions/${id}/read`),
  respond: (id, description) => workApi.post(`discussions/${id}/responses`, { description }),
  setStatus: (id, status) => workApi.patch(`discussions/${id}`, { status }),
  addPeople: (id, userIds) => workApi.post(`discussions/${id}/subscribers`, { userIds }),
  removePerson: (id, userId) => workApi.delete(`discussions/${id}/subscribers/${userId}`),
};
